import { useTranslation } from "react-i18next";

// Filtro periodo condiviso (Mese + Anno) con default "Tutti". Filtro puramente client-side.
export const matchPeriod = (dateStr, mon, yr) => {
  if (!mon && !yr) return true;
  const d = String(dateStr || "");
  if (!d) return false;
  if (yr && d.slice(0, 4) !== yr) return false;
  if (mon && d.slice(5, 7) !== mon) return false;
  return true;
};

export const PeriodFilter = ({ mon, yr, setMon, setYr, years = [], testid = "period-filter" }) => {
  const { t, i18n } = useTranslation();
  const months = Array.from({ length: 12 }, (_, i) => {
    const l = new Date(2000, i, 1).toLocaleDateString(i18n.language || "it", { month: "long" });
    return [String(i + 1).padStart(2, "0"), l.charAt(0).toUpperCase() + l.slice(1)];
  });
  return (
    <div className="flex gap-2 items-center" data-testid={testid}>
      <select className="yp-input !py-1 text-sm" value={mon} onChange={(e) => setMon(e.target.value)} data-testid={`${testid}-month`}>
        <option value="">{t("sadm.all_months")}</option>
        {months.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <select className="yp-input !py-1 text-sm w-28" value={yr} onChange={(e) => setYr(e.target.value)} data-testid={`${testid}-year`}>
        <option value="">{t("sadm.all_years")}</option>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
};
